<div style="display: flex; justify-content: space-between;">
    <div class="container">
        <div class="row upper-data">
            <div class="col col-6 company-info company-word-wrap">
                @if (!companyIsActive) {
                    <img [popover]="activatedByPopover"
                         [src]="inactiveUrl"
                         alt="Inactive"
                         class="status-img img-responsive float-end"
                         container="body"
                         placement="auto"
                         triggers="mouseenter:mouseleave">
                }
                <h3 (mouseenter)="addressPopoverOpened = true"
                    (mouseleave)="addressPopoverOpened = false">
                    <span [isOpen]="addressPopoverOpened"
                          [popover]="companyAddressPopover"
                          placement="bottom left"
                          triggers="">
                        {{ company.companyName }}
                    </span>
                </h3>
                <h4 style="margin-top: 0;">{{ subHeader }}</h4>
                <h5 [class.invisible]="!company.companyCode">
                    <span class="company-label">Company Code:</span> {{ company.companyCode }}
                </h5>
            </div>
            <div class="col col-6">
                <div>
                    <h4>Additional Information:</h4>
                    @if (company.completedPaymentPackageCount > 0) {
                        <div>
                            <a [sref]="{ target: 'paymentPackagesForCompany', options: { companyID: company.companyID } }"
                               anchor-route>Payment Packages</a>
                        </div>
                    }
                    @if (shouldDisplayPaymentBatches) {
                        <div>
                            <a (click)="goToPBCC()" class="pointer">
                                Payment Batches</a>
                        </div>
                    }
                    @if (hasInstancePrivateViewPermission) {
                        <div>
                            <a [sref]="{ target: 'forecastingBudgeting', options: { companyId: company.companyID } }"
                               anchor-route>
                                Forecasting@if (company.budgetsEnabled) {
                                <span>/Budgeting</span>
                            }
                            </a>
                        </div>
                    }
                    @if (accrualsEnabled && hasInstancePrivateViewPermission && company.accrualsEnabled) {
                        <div>
                            <a [sref]="{ target: 'accruals', options: { companyId: company.companyID } }"
                               anchor-route>Accruals</a>
                        </div>
                    }
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col col-6">
                @if (isTopLevel) {
                    <div>
                        <h4>Subsidiary Companies:</h4>
                        @if (subsidiaries.length) {
                            <ul
                                class="list-unstyled subsidiary-list">
                                @for (subsidiary of subsidiaries; track subsidiary) {
                                    <li>
                                        <a [sref]="{ target: 'company', options: { companyId: subsidiary.companyID } }"
                                           anchor-route>
                                            {{ subsidiary.companyCode ? subsidiary.companyCode + ' - ' : '' }}
                                            {{ subsidiary.companyName }}
                                            ({{ subsidiary.siteCount }}&nbsp;sites)&nbsp;&nbsp;
                                            @if (subsidiary.activityStatusID === 0) {
                                                <span>[INACTIVE]</span>
                                            }
                                        </a>
                                    </li>
                                }
                            </ul>
                        }
                        @if (subsidiaries.length === 0) {
                            <p>No subsidiaries.</p>
                        }
                        <div style="margin-left: 10px;">
                            @if (numInactiveSubsidiaries > 0 && !showInactiveSubsidiaries) {
                                <a (click)="showInactiveSubsidiariesClicked()"
                                   class="pointer">Show inactive subsidiaries
                                    ({{ numInactiveSubsidiaries }})</a>
                            }
                        </div>
                    </div>
                }
                @if (!isTopLevel && parentCompany) {
                    <div>
                        <h4>Top Level (Parent) Company:</h4>
                        <a [class.disabled]="parentCompany.noPermission" [sref]="{ target: 'company', options: { companyId: parentCompany.companyID } }"
                           anchor-route
                           style="font-size: large;">
                            {{ parentCompany.companyCode ? parentCompany.companyCode + ' - ' : '' }}
                            {{ parentCompany.companyName }}
                        </a>
                    </div>
                }
            </div>
            <div class="col col-6">
                @if (company.crmNumber || company.iamTenantId) {
                    <div>
                        <h4>External Connections</h4>
                        @if (hasInstancePrivateViewPermission && company.crmNumber) {
                            <h5>
                                <span class="field-header">CRM Number:</span> {{ company.crmNumber }}
                            </h5>
                        }
                        @if (isIAMEnabled) {
                            <h5 [class.invisible]="!(hasInstancePrivateViewPermission && company.iamTenantId)">
                                <span class="field-header">tax.com Tenant:</span> {{ company.iamTenantName }}
                            </h5>
                        }
                    </div>
                }
            </div>
        </div>
    </div>
    <div>
        @if (isTopLevel && hasInstancePrivateViewPermission) {
            <div>
                <button (click)="toggleFavorite()"
                        class="ace-btn has-icon btn-lg btn-primary"
                        helpContentId="company-info-panel.favorite"
                        helpTooltip
                        position="left">
                    @if (!isFavoriting) {
                        <span>
                            @if (!company.isFavorite) {
                                <i class="fa fa-star-o"></i>
                            }
                            @if (company.isFavorite) {
                                <i class="fa fa-star"></i>
                            }
                        </span>
                    }
                    @if (isFavoriting) {
                        <ws-ace-loader [inline]="true"></ws-ace-loader>
                    }
                </button>
            </div>
        }
        <div>
            <entity-attachments [(hasAttachments)]="company.hasAttachments"
                                [isNestedModal]="false"
                                [modalData]="attachmentsModel"
                                buttonClass="has-icon btn-lg"
                                helpContentId="company-info-panel.attachments"
                                helpTooltip
                                position="left">
            </entity-attachments>
        </div>
        @if (company.hasImages) {
            <div>
                <entity-attachments (hasImagesChange)="company.hasImages = $event"
                                    [forImages]="true"
                                    [isNestedModal]="false"
                                    [modalData]="attachmentsModel"
                                    buttonClass="has-icon btn-lg"
                                    helpContentId="company-info-panel.images" helpTooltip
                                    position="left">
                </entity-attachments>
            </div>
        }
        <div>
            <entity-comments [(hasComments)]="company.hasComments"
                             [modalData]="commentsModel"
                             buttonClass="has-icon btn-lg"
                             helpContentId="company-info-panel.comments"
                             helpTooltip
                             position="left">
            </entity-comments>
        </div>
    </div>
</div>

<ng-template #companyAddressPopover>
    <div style="word-break: break-all;">
        <address-view-edit [address]="defaultAddress" [isEditMode]="false"></address-view-edit>
        <div><a href="{{company.address.url}}" target="_blank">{{ company.address.url }}</a></div>
        <div style="margin-top: 10px;">
            <a (click)="launchAddressModal()" class="pointer">
                Address Details @if (company.entityAddresses.length > 1) {
                <span>({{ company.entityAddresses.length }})</span>
            }
            </a>
        </div>
    </div>
</ng-template>
